import React, { useEffect, useState } from "react";
import "./cartDetails.scss"
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareXmark } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { CustomEvent, serviceCall } from "../../Utils/ServiceUtils";

function CartDetails() {
  const [totalPriceVal, setTotalPriceVal] = useState(0);
  const [cartList, setCartList] = useState();

  useEffect(() => {
    getCartDetails();
  }, [])

  const getCartDetails = async () => {
    const resp = await serviceCall("GET", "/API/Cart/GetCartProducts");
    if (resp && !(resp.IsError === true)) {
        setCartList(resp);
        window.localStorage.setItem("CartDetails",JSON.stringify(resp));
        window.dispatchEvent(CustomEvent("storage",{"detail": {"key": "Cart"} }));
        totalPrice(resp);
    }
  }

  function totalPrice(data) {
    let price = 0;
    data.map((element) => (price = price + (element.Price * element.Quantity)))
    setTotalPriceVal(price);
  }

  async function removeProduct(evt, cartId, ProductId) {
    evt.preventDefault();
    const resp = await serviceCall("POST", "/API/Cart/DeleteCartProduct", cartId);
    if (resp && !(resp.IsError === true) && resp.succeeded) {
        getCartDetails();
    }
  }

  async function quantityUpdate(evt, Id, action, qty) {
    evt.preventDefault();
    if(action === "increase" || (action === "decrease" && qty > 1 )) {
      const resp = await serviceCall("PUT", `/API/Cart/${action === "increase" ? "IncreaseQuantity" : "DecreaseQuantity"}`, Id);
      if (resp && !(resp.IsError === true) && resp.succeeded) {
        getCartDetails();
      }
    }
  }

  return (
    <>
      <div className="cartDetailsPage">
        <div className="prdt-list">
          <div className="cartHeader">Items in Your Bag</div>
          {cartList && cartList.length > 0 && <span> {cartList.map((element, idx) => (
            <div key={idx} className="cart-item">
              <FontAwesomeIcon className="removeProdct" icon={faSquareXmark} onClick={(e) => removeProduct(e, element.Id, element.ProductId)} />
              <div className="cart-item-image">
                <img src={element.ImageUrl} alt="Product" />
              </div>
              <div className="cart-item-details">
                <h3>{element.Name}</h3>
                <p>Price: {element.Price}</p>
                <p>Quantity: <Button onClick={(e) => quantityUpdate(e, element.Id, "decrease", element.Quantity)}>-</Button> <input type="text" disabled={true} className="form-control qtyInputBox" value={element.Quantity}  /> <Button onClick={(e) => quantityUpdate(e, element.Id, "increase")}>+</Button> </p>
              </div>
            </div>
          ))}
            <div className="cart-total">
              <h2>Total Price: {totalPriceVal}</h2>
            </div>
            <div className="checkoutTop"></div>
            <div className="cart-total">
              <Link to="/checkOut" style={{ textDecoration: "none" }}>
                <Button className="checkoutBtn">Check Out</Button>
              </Link>
            </div>
          </span> } {cartList && cartList.length === 0 && <div className="bagEmpty">Your Bag is Empty....<span style={{ fontSize: "35px" }}>&#128092;</span></div>}
        </div>
      </div>
    </>
  );
}

export default CartDetails;